import { assign } from "xstate";

//Dynamically create the required guards for the history
const createBackTransitions = (targets: string[]) => {
  //Remove the previous state from the stack
  const previousStep = assign({
    stack: (context: any, event, meta) => {
      context.stack.pop();
      return context.stack;
    },
  });
  return targets.map((target) => ({
    target: target,
    actions: previousStep,
    cond: (context: any) => {
      if (context.stack.length < 1) {
        return false;
      }
      return context.stack[context.stack.length - 1].value === target;
    },
  }));
};

export default createBackTransitions